import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { useMutation, useApolloClient } from "react-apollo";
import { Fieldset } from "rbx";

import Section from "../Section";

import {
  UPDATE_ROUTE_PRODUCT_MUTATION,
  DELETE_ROUTE_PRODUCT_MUTATION
} from "../../graphql/Routes/RouteProducts.graphql";
import { ourToast as toast } from "../../utils";
import { SINGLE_PRODUCT_QUERY } from "../../graphql/Products/Products.graphql";

import RouteProductDispatcherForm from "./RouteProductDispatcherForm";
import RouteProductBillingForm from "./RouteProductBillingForm";

import { EditFormButtonGroup } from "../inputs";

const DEFAULT_STATE = {
  ProductNoRecIdRef: "",
  Rate: "0",
  Description: "",
  HazmatCode: "",
  UOMRecIdRef: "",
  InternalComm: "",
  ExternalComm: "",
  Percentage: ""
};

const EditRouteProductForm = ({
  routeProduct,
  isAddingAsDispatcher = false,
  setModalOpen
}) => {
  const client = useApolloClient();

  const [updateRoute, { loading }] = useMutation(
    UPDATE_ROUTE_PRODUCT_MUTATION,
    {
      refetchQueries: ["ALL_ROUTE_PRODUCTS_QUERY"]
    }
  );

  const [inputs, setInputs] = useState(DEFAULT_STATE);

  const handleChange = e => {
    e.persist();
    setInputs(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };
  useEffect(() => {
    if (routeProduct) {
      setInputs(prev => ({
        ...prev,
        Description: routeProduct.ProdDescription,
        ...routeProduct
      }));
    }
  }, [routeProduct]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: ProductData } = await client.query({
          query: SINGLE_PRODUCT_QUERY,
          variables: {
            where: {
              RecId: parseInt(inputs.ProductNoRecIdRef)
            }
          }
        });
        if (ProductData && ProductData.Product) {
          setInputs(prev => ({
            ...prev,
            // Rate: ProductData.Product.Price
            //   ? ProductData.Product.Price
            //   : inputs.Rate,
            // Description: ProductData.Product.Description,
            HazmatCode: ProductData.Product.HazmatCode,
            ProductCatgRecIdRef: ProductData.Product.ProductCatgRecIdRef
            // Percentage: ProductData.Product.Percentage,
            // UOMRecIdRef: ProductData.Product.UOMRecIdRef
          }));
        }
      } catch (err) {
        toast.error("Error getting Product");
      }
    };
    if (inputs.ProductNoRecIdRef) {
      fetchData();
    }
  }, [client, inputs.ProductNoRecIdRef, inputs.Rate]);

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      await updateRoute({
        variables: {
          data: {
            ProductNoRecIdRef: parseInt(inputs.ProductNoRecIdRef),
            Rate: inputs.Rate ? parseFloat(inputs.Rate) : null,
            UOMRecIdRef: inputs.UOMRecIdRef
              ? parseInt(inputs.UOMRecIdRef)
              : null,
            InternalComm: inputs.InternalComm,
            ExternalComm: inputs.ExternalComm,
            Percentage: parseFloat(inputs.Percentage),
            ProductCatgRecIdRef: parseInt(inputs.ProductCatgRecIdRef),
            ProdDescription: inputs.Description
          },
          where: {
            RecId: routeProduct.RecId
          }
        }
      });
      setModalOpen(false, "");
      toast.success("Route Product updates successfully.");
    } catch (err) {
      toast.error("Error updating Route Product.");
    }
  };
  return (
    <Section title="Edit Route Product">
      <form id="edit-route-product" method="POST" onSubmit={handleSubmit}>
        <Fieldset aria-busy={loading}>
          {isAddingAsDispatcher ? (
            <RouteProductDispatcherForm
              inputs={inputs}
              onChange={handleChange}
            />
          ) : (
            <RouteProductBillingForm inputs={inputs} onChange={handleChange} />
          )}
          <EditFormButtonGroup
            deleteMutation={DELETE_ROUTE_PRODUCT_MUTATION}
            form="edit-route-product"
            refetchQueries={["ALL_ROUTE_PRODUCTS_QUERY"]}
            variables={{ where: { RecId: routeProduct.RecId } }}
            onComplete={() => setModalOpen(false, "")}
          />
        </Fieldset>
      </form>
    </Section>
  );
};

EditRouteProductForm.propTypes = {
  setModalOpen: PropTypes.func,
  routeProduct: PropTypes.object,
  isAddingAsDispatcher: PropTypes.bool
};

export default EditRouteProductForm;
